module.exports = __webpack_public_path__ + "static/dc-sao-paulo-5-ea3b8e13be642d6ee51d8e49ed91a3c6.jpg";